var render = function render(){var _vm=this,_c=_vm._self._c;return _c('move-template',{attrs:{"automatic":_vm.automatic,"order-type":_vm.orderType,"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }